import React, { useCallback, useState } from 'react'
import { components } from 'react-select'

import useStyles from './styles'

export default function SelectSingleValue(props) {
  const classes = useStyles({
    bigIcon: props.selectProps.bigIcon,
    isSmall: props.selectProps.isSmall
  })
  const Icon = props.data.icon
  const img = props.data.img

  const [imageUrlFailed, setImageUrlFailed] = useState(false)

  const handleImageError = useCallback(() => {
    setImageUrlFailed(true)
  }, [])

  const handleImageLoad = useCallback(() => {
    setImageUrlFailed(false)
  }, [])

  return (
    <components.SingleValue {...props}>
      <div className={classes.value}>
        {Icon && (
          <section className={classes.iconContainer}>
            <Icon />
          </section>
        )}
        {img && (
          <div className={classes.iconContainer} style={{ display: imageUrlFailed ? 'none' : 'flex' }}>
            <img src={img} alt="icon" onError={handleImageError} onLoad={handleImageLoad} />
          </div>
        )}
        <div className={classes.info}>
          <div className={classes.label}>{props.data.label}</div>
        </div>
      </div>
    </components.SingleValue>
  )
}
